// ✅ REFACTORED FILE (V6.4+ Data Router Migration - FINAL FIX)
// FILE: src/index.js
// REASON: This file must *only* render the RouterProvider. All Context Providers
// must be moved *inside* the router config (in routes.js) to fix the
// "useNavigate() may be used only in the context of a <Router>" error.
// Golden Rule: Preserved Suspense/i18n setup.

import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

// TRADER-JOURNAL-DEV-BP-001 (i18n) - Step 4: (Preserved)
import './lib/i18n.js';

import { FullScreenLoader } from './components/ui/Loader';

// ✅ REFACTOR (1/2): Import new router utilities
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

// ✅ REFACTOR (2/2): Import the new route config object from routes.js
import { routesConfig } from './routes';

// ================== SCALABILITY UPDATE ==================
// Import React Query Client
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const ReactQueryDevtools = process.env.NODE_ENV === 'development'
  ? React.lazy(() =>
      import('@tanstack/react-query-devtools').then((module) => ({ default: module.ReactQueryDevtools }))
    )
  : null;

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false, // Prevent massive refetches on tab switch
      refetchOnReconnect: false,
      retry: 1, // Retry failed requests once before showing an error
      staleTime: 60 * 1000,
    },
  },
});
// ================== END SCALABILITY UPDATE ==================

// Create the new Data Router
const router = createBrowserRouter(routesConfig);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* (Preserved) i18n Suspense Wrapper */}
    <Suspense fallback={<FullScreenLoader />}>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
        {ReactQueryDevtools ? (
          <Suspense fallback={null}>
            <ReactQueryDevtools initialIsOpen={false} />
          </Suspense>
        ) : null}
      </QueryClientProvider>
    </Suspense>
  </React.StrictMode>
);
